import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as Logo } from '../assets/imageItems/item_justdoit_icon.svg';
export default function TruckIcon() {
  return <SvgIcon component={Logo} viewBox="0 0 530 288" />;
}
